import type { FunctionMeta } from '../function.model';

// =============================================================================
// PARAMS - Mathematical definition
// =============================================================================

/** Square root function parameters: a√(x-h) + k */
export interface SqrtParams {
  /** Vertical scale/reflection */
  a: number;
  /** Horizontal shift (start of domain) */
  h: number;
  /** Vertical shift */
  k: number;
}

// =============================================================================
// META - Function configuration (type-checked)
// =============================================================================

/**
 * Configuration metadata for square root functions.
 * Translate behaviors map to h (x) and k (y) parameters.
 */
export const SQRT_META: FunctionMeta<SqrtParams> = {
  availableFeatures: [
    'handle',
    'roots',
    'tangent',
    'secant',
    'derivative',
    'intersection',
    'yIntercept',
    'trajectory',
    'monotonicity',
    'functionArea',
    'intersectionArea',
    'domain',
    'range',
  ],
  handleConfigs: {
    translate: { xParam: 'h', yParam: 'k' },
    'translate-x': { xParam: 'h', yParam: 'k' },
    'translate-y': { xParam: 'h', yParam: 'k' },
  },
  defaultParams: {
    a: 1,
    h: 0,
    k: 0,
  },
  defaultRanges: {
    a: [-5, 5],
    h: [-10, 10],
    k: [-10, 10],
  },
};
